import { render, staticRenderFns } from "./TelephonyDisambiguation.vue?vue&type=template&id=60af913b&scoped=true"
import script from "./TelephonyDisambiguation.vue?vue&type=script&lang=ts"
export * from "./TelephonyDisambiguation.vue?vue&type=script&lang=ts"
import style0 from "./TelephonyDisambiguation.vue?vue&type=style&index=0&id=60af913b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60af913b",
  null
  
)

export default component.exports